

if ($("#user_avatar").children().length === 0) {
    $("#user_avatar").append(
        frappe.avatar(frappe.session.user, "avatar-medium")
    );
}

$(document).ready(() => {
    if (frappe.session.user && frappe.session.user !== "Guest") {
        load_notification();
    }
});

$(document).on("click", "#notification_bell", () => {
    if (frappe.session.user && frappe.session.user !== "Guest") {
        load_notification();
    }
});

$(document).on("click", ".mark_as_read", (e) => {

    const el = $(e.currentTarget);

    frappe.call({
        method: "nxt_theme.events.notification_log.mark_as_read",
        args: {
            docname: el.data("docname")
        },
        callback: (r) => {
            if (!r.exc) {
            	load_notification();

            	const dt = el.data("document_type");
            	const dn = el.data("document_name");

            	if (dt && dn) {
            		frappe.set_route("Form", dt, dn);
            	}
            }
        }
    });
});
$(document).on("click", "#mark_all_as_read", () => {
    frappe.call({
        method: "nxt_theme.events.notification_log.mark_all_as_read",
        callback: function (r) {
            if (!r.exc) {
                load_notification(); // Reload the notifications
                update_unread_count(0); // Update unread count to zero
            } else {
                console.error("Error marking notifications as read:", r.exc);
            }
        }
    });
});

const load_notification = () => {
      if (!frappe.session.user || frappe.session.user === "Guest") {
        return;
    }
    
    // Show loading state
    $("#notification_list").html(`
        <div class="flex items-center justify-center h-full py-10">
            <svg width="25" viewBox="0 0 44 44" stroke="#64748b">
                <circle cx="22" cy="22" r="1">
                    <animate attributeName="r" dur="1.5s" values="1; 20" repeatCount="indefinite"></animate>
                    <animate attributeName="stroke-opacity" dur="1.5s" values="1; 0" repeatCount="indefinite"></animate>
                </circle>
            </svg>
        </div>
    `);

    frappe.call({
        method: "nxt_theme.events.notification_log.get_notification_logs",
        callback: (r) => {
            const logs = (r.message && r.message.notification_logs) || [];
            let unread_count = 0;

            let html = "";

            if (logs.length === 0) {
                html = `<div class="p-4 text-center text-slate-500">No notifications</div>`;
            }

            for (const n of logs) {
                if (!n.read) unread_count++;

                html += `
            <a class="flex items-center rounded-xl px-3 py-2.5 hover:bg-slate-100/80 mark_as_read"
                data-docname="${n.name}"
                data-document_type="${n.document_type}"
                data-document_name="${n.document_name}"
                href="javascript:;">
                <div class="image-fit h-11 w-11 overflow-hidden rounded-full border-2 border-slate-200/70">
                    ${frappe.avatar(n.from_user, 'w-100 h-100')}
                </div>
                <div class="sm:ml-5 flex-1">
                    <div class="font-medium">${n.subject || "No Subject"}</div>
                    <div class="mt-0.5 text-slate-500">
                        ${n.email_content || ""}
                    </div>
                    <div class="mt-1.5 text-xs text-slate-500">
                        ${frappe.datetime.str_to_user(n.creation)}
                    </div>
                </div>
                ${!n.read ? `<div class="ml-auto h-2 w-2 rounded-full bg-primary"></div>` : ""}
            </a>
        `;
            }

            $("#notification_list").html(html);
            update_unread_count(unread_count);
        }
    });
};
const update_unread_count = (count) => {
    const el = $("#notification_count");
    if (count > 0) {
        el.removeClass("hidden").text(count);
    } else {
        el.addClass("hidden").text("");
    }
};


